import { useContext, useMemo } from 'react';
import { ThemeContext } from '../providers/theme-provider/context';
import { resolveTheme } from '../resolve-theme';
import { DEFAULT_THEME_ID, ThemeDomEnum } from '../enums';
import { resolveAsset } from '../assets/resolve-asset';

function getThemeIdFromRoot(rootId) {
	if (typeof document === 'undefined') {
		return null;
	}

	const el = document.getElementById(rootId);

	return el?.dataset?.theme || null;
}

export function useThemeAssets(options = {}) {
	const {
		rootId = ThemeDomEnum.ROOT_ID,
		defaultThemeId = DEFAULT_THEME_ID,
	} = options;
	const ctx = useContext(ThemeContext);

	// 有 Provider：直接用（不需要每次 query DOM）
	if (ctx?.assets) {
		return ctx.assets;
	}

	// 沒 Provider：fallback 直接讀 DOM data-theme
	return useMemo(() => {
		const themeId = getThemeIdFromRoot(rootId) || defaultThemeId;

		return resolveTheme(themeId).assets;
	}, [rootId, defaultThemeId]);
}

export function useThemeAsset(assetKey, options) {
	const {
		fallback = null,
		...themeOptions
	} = options || {};
	const assets = useThemeAssets(themeOptions);

	return resolveAsset(assets, assetKey, fallback);
}

export function useThemeAssetMap(keyMap = {}, options) {
	const {
		fallback = null,
		...themeOptions
	} = options || {};
	const assets = useThemeAssets(themeOptions);

	return useMemo(() => {
		const result = {};

		Object.entries(keyMap).forEach(([alias, key]) => {
			result[alias] = resolveAsset(assets, key, fallback);
		});

		return result;
	}, [assets, fallback, keyMap]);
}
